<script setup>
import { computed } from 'vue';
import { useAgentName } from 'dashboard/composables/useAgentName';
import { useI18n } from 'vue-i18n';

const { agentName } = useAgentName();
const { t } = useI18n();

// Mensagem de loading dinâmica: "{agentName} está pensando"
const loaderMessage = computed(() => {
  return `${agentName.value} ${t('CAPTAIN.COPILOT.LOADER_SUFFIX')}`;
});
</script>

<template>
  <div class="flex justify-start">
    <div class="flex items-center space-x-2">
      <span class="text-n-iris-11 font-medium">
        {{ loaderMessage }}
      </span>
      <div class="flex space-x-1">
        <div
          class="w-2 h-2 rounded-full bg-n-iris-9 animate-bounce [animation-delay:-0.3s]"
        />
        <div
          class="w-2 h-2 rounded-full bg-n-iris-9 animate-bounce [animation-delay:-0.15s]"
        />
        <div class="w-2 h-2 rounded-full bg-n-iris-9 animate-bounce" />
      </div>
    </div>
  </div>
</template>
